export enum OrderState {
    Quote = 1,
    Order,
    Paid,
    Shipped,
    Delivered
}